const calculateWorkFromHome = (leaveData: any) => {
    const workfromhome = leaveData?.[0]?.history?.filter((data: any) => {
        return data?.leave_type_id === 4 || data?.leave_type_id === '4';
    }).reduce((acc: any, cur: any) => {
        return acc + cur.duration;
    }, 0);


    const lossOfPay = leaveData?.[0]?.history?.filter((data: any) => {
        return data?.leave_type_id === 6 || data?.leave_type_id === '4';
    }).reduce((acc: any, cur: any) => {
        return acc + cur.duration;
    }, 0);
    return {
        workfromhome,
        lossOfPay
    };
};

export default calculateWorkFromHome;
